import { render, staticRenderFns } from "./storicoInviiReportFornitore.vue?vue&type=template&id=15ef990b&"
import script from "./storicoInviiReportFornitore.vue.ts?vue&type=script&lang=ts&"
export * from "./storicoInviiReportFornitore.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports